import i18n from "i18next";
import moment from "moment";

const weekdays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
];

const weekdays_short = [
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat",
    "sun"
];

const getWeekdayFromDate = function(date){
    return i18n.t(weekdays_short[moment(date).weekday()]);
};
const formatDateForBottomBar = function(date){
    return moment(date).format("DD.MM.").toString();
};

export {getWeekdayFromDate, formatDateForBottomBar}
